import { render, staticRenderFns } from "./MembroNew.vue?vue&type=template&id=261b59b8&scoped=true&"
import script from "./MembroNew.vue?vue&type=script&lang=js&"
export * from "./MembroNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b59b8",
  null
  
)

export default component.exports